module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.message) ? _c('div', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-634cbd79!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/ValidationErrors.vue
// module id = 390
// module chunks = 1